<script lang="ts">
	import type { SearchCombobox } from '../../utils/createSearchCombobox';

	interface Props {
		combobox: SearchCombobox;
		children?: import('svelte').Snippet;
	}

	let { combobox, children }: Props = $props();

	let comboboxOpen = $derived(combobox.states.open);
</script>

<div
	class={$comboboxOpen ? 'h-0 overflow-hidden lg:h-auto [&+footer]:h-0 [&+footer]:lg:h-auto' : ''}
>
	{@render children?.()}
</div>
